import React from "react";
import { Link } from "react-router-dom";
import columns from "./ProductsColumns";
import Loader from "@pillvery/components/utility/loader";
import { useSelector } from "react-redux";
import { routes } from "../../../config/pillveryVariables";
import ConfirmModal from "../../../components/ConfirmModal";
import Policies from "../../../Policies/Policies";
import _ from "lodash";

var Barcode = require("react-barcode");

export default function ProductsListTable({
  products,
  handleDeleteProduct,
  report = false,
  params,
  underReports = false,
}) {
  var dateFormat = require("dateformat");
  const { loading } = useSelector((state) => state.Products);
  if (underReports && columns[11].key !== "profit_margin") {
    columns.splice(11, 0, {
      title: "Profit Margin",
      key: "profit_margin",
    });
  }
  if (!underReports && report && columns[11].key === "total_sales") {
    columns.splice(11, 1, {
      title: "Total Value",
      key: "total_sales",
    });
  }
  return (
    <div className="table-responsive" style={{ minHeight: "300px" }}>
      {loading ? <Loader /> : ""}
      <table className="table">
        <thead style={{ backgroundColor: "#F4F2F2", textAlign: "center" }}>
          <tr>
            {columns.map((column, index) => (
              <>
                {index === 0 ? (
                  <th className="text-left">{column.title}</th>
                ) : (
                  <th className="">{column.title}</th>
                )}
              </>
            ))}
            {!report &&
            (Policies?.ListingPolicy?.update !== false ||
              Policies?.ListingPolicy?.delete !== false) ? (
              <th className="" colSpan={2}>
                Action
              </th>
            ) : null}
          </tr>
        </thead>
        <tbody>
          {products.map((singleData, idx) => (
            <tr>
              {columns.map((column, index) => (
                <Column
                  data={singleData}
                  column={column}
                  index={index}
                  idx={idx}
                />
              ))}
              {!report &&
              (Policies?.ListingPolicy?.update !== false ||
                Policies?.ListingPolicy?.delete !== false) ? (
                <ActionBtns idx={idx} data={singleData} />
              ) : null}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  function Image({ src }) {
    return (
      <div>
        <img src={src || "/images/picon.jpg"} alt="picon" />
      </div>
    );
  }

  function Column({ data, column, index, idx }) {
    var category_path = {};
    data?.category_path?.forEach((path) => {
      category_path = {
        ...category_path,
        [path?.path[0]?.name]: [],
      };
    });
    data?.category_path?.forEach((path) => {
      category_path = {
        ...category_path,
        [path?.path[0]?.name]: [
          ...category_path[path?.path[0]?.name],
          path?.path[1]?.name,
        ],
      };
    });

    var cvategoriesKeys = Object.keys(category_path);

    if (column.index) {
      return <td>{params.limit * (params.page - 1) + idx + 1}</td>;
    }

    if (column.key === "images") {
      return (
        <td style={{ minWidth: 150, position: "relative" }}>
          {data?.images?.length ? (
            <img
              src={data.images[0] + "?q=" + new Date().getTime()}
              alt={"product"}
            />
          ) : (
            <img src={"/images/Color-99A0AA.png"} alt="placeholder color" />
          )}
          {data?.is_near_expiry && (
            <span
              style={{
                position: "absolute",

                marginLeft: 5,
                backgroundColor: "#DE5F75",
                borderRadius: 17,
                justifyContent: "center",
                alignItems: "flex-end",

                alignSelf: "flex-start",
                height: 18,
              }}
            >
              <text
                style={{
                  color: "#fff",
                  fontSize: 12,
                  marginLeft: 5,
                  marginRight: 5,
                }}
              >
                near expire
              </text>
            </span>
          )}
        </td>
      );
    }

    if (column.barcode) {
      const barcodes = _.get(data, "barcodes", [1234567890123]);
      const list = barcodes.map(
        (barcode) =>
          barcode && (
            <Barcode value={barcode} width={1} height={30} fontSize={15} />
          )
      );
      return <td>{list}</td>;
    } else if (column.key === "category") {
      return (
        <td>
          {cvategoriesKeys.map((category) => {
            if (category) {
              return (
                <div className="p-2 pb-3">
                  <b>{category}</b>
                </div>
              );
            }
            return "__";
          })}
        </td>
      );
    } else if (column.key === "sub_category") {
      return (
        <td>
          {cvategoriesKeys.map((category) => {
            if (category_path[category].length) {
              return (
                <div className="mb-1 text-left">
                  {category_path[category].map((item) => (
                    <span className="badge badge-pill badge-light m-1">
                      {item}
                    </span>
                  ))}
                </div>
              );
            }
            return "__";
          })}
        </td>
      );
    } else if (column.key === "sub_category_2") {
      var category_path = {};
      data?.category_path.map((path) => {
        category_path = {
          ...category_path,
          [path?.path[0]?.name]: [],
        };
      });
      data?.category_path.map((path) => {
        category_path = {
          ...category_path,
          [path?.path[0]?.name]: [
            ...category_path[path?.path[0]?.name],
            path?.path[1]?.name,
          ],
        };
      });
      var cvategoriesKeys = Object.keys(category_path);

      return (
        <td>
          {cvategoriesKeys.map((category) => (
            <p>{category_path[category][1] || "__"}</p>
          ))}
        </td>
      );
    } else if (column.key === "sub_category_3") {
      var category_path = {};
      data?.category_path.map((path) => {
        category_path = {
          ...category_path,
          [path?.path[0]?.name]: [],
        };
      });
      data?.category_path.map((path) => {
        category_path = {
          ...category_path,
          [path?.path[0]?.name]: [
            ...category_path[path?.path[0]?.name],
            path?.path[1]?.name,
          ],
        };
      });
      var cvategoriesKeys = Object.keys(category_path);

      return (
        <td>
          {cvategoriesKeys.map((category) => (
            <p>{category_path[category][2] || "__"}</p>
          ))}
        </td>
      );
    } else if (column.key === "sub_category_4") {
      var category_path = {};
      data?.category_path.map((path) => {
        category_path = {
          ...category_path,
          [path?.path[0]?.name]: [],
        };
      });
      data?.category_path.map((path) => {
        category_path = {
          ...category_path,
          [path?.path[0]?.name]: [
            ...category_path[path?.path[0]?.name],
            path?.path[1]?.name,
          ],
        };
      });
      var cvategoriesKeys = Object.keys(category_path);

      return (
        <td>
          {cvategoriesKeys.map((category) => (
            <p>{category_path[category][3] || "__"}</p>
          ))}
        </td>
      );
    } else if (column.key === "brand") {
      return <td>{data?.brand_path[0]?.path?.[0]?.name || "__"}</td>;
    } else if (column.key === "expiry_date" && data?.is_near_expiry) {
      return <td>{dateFormat(data[column.key], "dd mmm yyyy ") || "__"}</td>;
    } else if (column.key === "supplier_name") {
      return <td>{data?.supplier_name || "Admin"}</td>;
    } else if (column.key === "offer_percentage") {
      // Only show for near expiry items
      return <td>{data?.is_near_expiry ? (data?.offer_percentage || "__") : "__"}</td>;
    } else if (column.key === "regular_discount") {
      // Only show for regular items with discount
      return <td>{!data?.is_near_expiry && data?.offer_percentage > 0 ? (data?.offer_percentage || "__") : "__"}</td>;
    } else if (column.key === "total_sales") {
      return <td>{data?.total_sales?.toFixed(3) || "__"}</td>;
    } else if (column.key === "profit_margin") {
      return (
        <td>{((data?.price || 0) - (data?.cost || 0)).toFixed(3) || "__"}</td>
      );
    } else if (column.key === "orders_count") {
      return <td>{data[column.key] || "0"}</td>;
    }

    if (column.date && data[column.key]) {
      return (
        <td>{dateFormat(data[column.key], "dd mmm yyyy - h:MM TT") || "__"}</td>
      );
    }

    if (column.image) {
      return (
        <td className="py-1 text-center">
          <Image src={data[column.key]} />
        </td>
      );
    }
    if (index === 0) {
      return <td className="text-left">{data[column.key] != null ? data[column.key] : "__"}</td>;
    }
    if (column.orders_count) {
      return <td className="text-left">{data[column.key] != null ? data[column.key] : "__"}</td>;
    }
    if (column.digit) {
      return <td>{data[column.key] != null ? (data[column.key]?.toFixed?.(3) || "__") : "__"}</td>;
    }
    return <td>{data[column.key] != null ? data[column.key] : "__"}</td>;
  }

  function ActionBtns({ idx, data }) {
    return (
      <>
        {Policies?.ListingPolicy?.update !== false ? (
          <td>
            <Link
              key={idx}
              to={routes.PRODUCTS + "/" + data?._id + "/update"}
              className="btn btn-fw btn-outline-primary"
              style={{ fontSize: 13, padding: 6, width: 65 }}
              target={"_blank"}
            >
              <span className="mdi mdi-lead-pencil"></span> Edit
            </Link>
          </td>
        ) : null}

        {Policies?.ListingPolicy?.delete !== false ? (
          <td>
            <div className="dropdown dropright card-menu-dropdown">
              <button
                className="btn"
                type="button"
                id="cardMenuButton6"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i className="mdi mdi-dots-horizontal card-menu-btn"></i>
              </button>
              <div className="dropdown-menu" aria-labelledby="cardMenuButton6">
                <Link
                  className="dropdown-item"
                  onClick={() =>
                    ConfirmModal({
                      key: data?._id,
                      title: "Are you sure to Delete record!",
                      description: "",
                      onOk: handleDeleteProduct,
                      id: data._id,
                    })
                  }
                >
                  Delete
                </Link>
              </div>
            </div>
          </td>
        ) : null}
      </>
    );
  }
}
